//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class WebsitePageUpdateItem extends ItemBase {
    WebsiteID: string | null = null;
    ParentPageID: string | null = null;
    Description: string | null = null;
    InMenu: boolean = false;
    Keywords: string[] = [];
    OrderIndex: number = 0;
    RobotsIndex: boolean = false;
    SEOTitle: string | null = null;
    Title: string | null = null;
    IsHomepage: boolean = false;

    constructor(initializer?: Partial<WebsitePageUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsitePageUpdateItem";
}
